// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__20KRz","title":"Info_title__MwwKS","links":"Info_links__3PXBX","link":"Info_link__I9BnA","logo":"Info_logo__3yZID"};